import { Theme } from "@mui/material";

const spacing = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export function createVerticalSpacing(theme: Theme) {
  const result: { [key: string]: any } = {};
  // v5: theme.spacing() returns a px string; extract the numeric base unit
  const unit = parseInt(theme.spacing(1), 10);
  spacing.forEach((space) => {
    result[`vspacing-xs-${space}`] = {
      marginTop: (unit * space) / -2,
      marginBottom: (unit * space) / -2,
      "& > .MuiGrid-item": {
        paddingTop: (unit * space) / 2,
        paddingBottom: (unit * space) / 2,
      },
    };
  });
  return result;
}
